import StatusChangedMsg from '@apptypes/WebsocketUserStatus.ts';
import { ComponentName } from '@constants';
import { enableModal } from '@state/reducers/modals.ts';
import { setDisableLogoutModal, setLogout } from '@state/reducers/user.ts';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketLogoutWatcher() {
  const { getLatest } = useSocket();
  const dispatch = useDispatch();
  const loggedOut: StatusChangedMsg | undefined = getLatest('session_ended');

  useEffect(() => {
    if (loggedOut) {
      var gambleTimeReachedReasons = [2, 10, 11, 12];
      if (
        //@ts-ignore
        gambleTimeReachedReasons.includes(loggedOut.data?.logout_reason)
      ) {
        dispatch(enableModal(ComponentName.PlayerGambleTimeReachedModal));
        dispatch(setLogout());
        dispatch(setDisableLogoutModal(true));
      }
      dispatch(setLogout());
    }
  }, [dispatch, loggedOut]);

  return null;
}
